// extracted by mini-css-extract-plugin
export default {"logoholder":"LogoHolder_logoholder__ZyGMF","logo":"LogoHolder_logo__iLFbM"};